<template>
  <div>
    <div v-for="game in compitions" :key="game.name">
      <v-list-item
        :id="game.name"
        :key="game.name"
        :to="{
          name: 'sportsbook-category-subCategory',
          params: { category: gameName, subCategory: game._id }
        }"
        dense
      >
        <v-list-item-content>
          <v-list-item-title>
            {{ game.name }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider :key="'divider' + game.name"></v-divider>
    </div>
  </div>
</template>

<script>
// import { mapState } from 'vuex'
export default {
  name: 'SportbookCategory',
  props: {
    compitions: { type: Array, default: () => [], required: true },
    orientation: { type: String, default: 'horizontal' }
  },
  data() {
    return {
      model: null,
      scrollClass: 'left-main'
    }
  },
  computed: {
    gameName() {
      if (this.$route.params.category) {
        return this.$route.params.category
      }
      return 'Cricket'
    },
    eventGameData() {
      return this.$route.params.subCategory
    }
    // ...mapState({
    //   loading: (state) => state.sportsbookCategory.loading,
    //   compitions: (state) => state.sportsbookCategory.competionData
    // })
  },
  // async created() {
  //   try {
  //     if (this.$route.params.category && !this.$route.params.subCategory) {
  //       this.scrollClass = 'left-main-category'
  //       await this.$store.dispatch(
  //         'sportsbookCategory/getCompetition',
  //         this.$route.params.category
  //       )
  //     } else {
  //     }
  //   } catch (error) {}
  // },

  // beforeDestroy() {
  //   this.$store.commit('sportsbookCategory/empty_data')
  // },

  methods: {
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>
